import React, {useState,useContext, useEffect,useRef, ChangeEventHandler } from "react";
import { Row,Col } from "reactstrap";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import { PageContext } from "./PageContext";
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { Input, InputChangeEvent, TextAreaChangeEvent } from '@progress/kendo-react-inputs';
import { Field, FieldWrapper, Form, FormElement, FormRenderProps, FormSubmitClickEvent } from '@progress/kendo-react-form';
import {Upload, UploadFileInfo, UploadOnAddEvent, UploadOnRemoveEvent} from '@progress/kendo-react-upload';
import { FloatingLabel, Label, Hint, Error } from '@progress/kendo-react-labels';
import { Stepper } from '@progress/kendo-react-layout';
import { Button } from '@progress/kendo-react-buttons';
import { SubmitBasic } from './SubmitBasic';
import { ToningRequest } from "../services/interfaces";
import { getMMCOBType, getMMJobTypes, getMMColorOptions, getMMJobHistory,getMMReturnFormat, getMMSites, getMMToningPresets, getMMTurnTimes, submitToningRequest } from "../services/apiService";
import { ConfirmDialog } from "./ConfirmDialog";
import { UserContext } from "./UserContext";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { fileTypes } from './Configuration';
import { FileType } from '../services/interfaces';
import { AlertDialog } from "./ConfirmDialog";

interface MMSubmissionFormProps{
    title:string;
    type:string;
    onClose:()=>void;
}




export function MMSubmissionForm(props:MMSubmissionFormProps){
    const [width, setWidth]=useState(800);
    const [height, setHeight]=useState(800);
    const [formState, setFormState] = useState({});
    const [stepValid, setStepValid] = useState(false);
    const [windowContent, setWindowContent]=useState("form");
    const [showValidationAlert, setShowValidationAlert]=useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [uploadResults, setUploadResults] = useState<any[]>([]);
    const [uploadComplete, setUploadComplete]=useState(false);
    const [showCloseConfirm, setShowCloseConfirm]= useState(false);
    const pageContext=useContext(PageContext);
    const userContext = useContext(UserContext);
    const [types, setTypes] = useState<FileType[]>([]);
    const [typeLimit,setTypeLimit]=useState<string[]>([]);
    const [noFiles, setNoFiles]=useState(false);
    const [newRequest,setNewRequest] = useState<ToningRequest>({
        tnPath:"",        
        tnSiteCode:"",
        tnPreset:"", 
        tnDueWithin:"", 
        tnJobType:"", 
        tnReturnType:"", 
        tnColor:"", 
        tnCropping:"", 
        tnCroppingX:"", 
        tnCroppingY:"", 
        tnCOBType:"", 
        tnReturnFormat:"", 
        tnReturnRes:"", 
        tnInstructions:"", 
        tnCustomer:"", 
        tnJobDescription:"", 
        tnFileList:[]
    });

    const [siteList, setSiteList]=useState<any[]>([]);
    const [toningPresetList, setToningPresetList]=useState([]);
    const [turnaroundList, setTurnaroundList]=useState([]);
    const [jobTypeList, setJobTypeList]=useState([]);
    const [colorOptionList, setColorOptionList]=useState([]);
    const [cobTypeList, setCOBTypeList]=useState([]);
    const [retFormatList, setRetFormatList]=useState([]);
    const [lockSite,setLockSite]=useState(false);
    const [lockDueWithin, setLockDueWithin]=useState(false);
    const [lockColor,setLockColor]=useState(false);
    const [lockJobType,setLockJobType]=useState(false);
    const [lockCropping,setLockCropping]=useState(false);
    const [lockCOBType,setLockCOBType]=useState(false);
    const [lockRetFormat, setLockRetFormat]=useState(false);
    const [lockRes,setLockRes]=useState(false);

    const saveUploadResults=(data:any)=>{       
        console.log(data);
        var prevData = uploadResults;
        console.log(prevData);
        prevData.push(data);
        setUploadResults(prevData);
    }

    const completeUpload=()=>{
        setUploadComplete(true);
    }

    const closeConfirmWindow=()=>{
        setShowCloseConfirm(false);
    }
   
    const confirmClose=()=>{
        setShowCloseConfirm(true);
    }

    const onLoad=()=>{
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        
        setWidth(vw*.5);
        setHeight(vh*.75);
        getMMSites().then(data=>{
            setSiteList(data);
        });
        getMMTurnTimes().then(data=>{
            setTurnaroundList(data);
        })
        getMMJobTypes().then(data=>{
            setJobTypeList(data);
        })
        getMMColorOptions().then(data=>{
            setColorOptionList(data);
        })
        getMMCOBType().then(data=>{
            setCOBTypeList(data);
        })
         getMMReturnFormat().then(data=>{
            setRetFormatList(data);
        })
    }

    const hideFileWarning=()=>{
        setNoFiles(false);
    }

    const confirmCloseWindow=()=>{
        setShowCloseConfirm(false);
        props.onClose();
    }

    const setUserSite =()=>{
        const userSite = userContext?.user.siteCode;
        if (userSite){
            siteList.forEach(itm=>{
                if (itm.mmSiteCode===userSite){
                    setNewRequest(prevObject => ({
                        ...prevObject,
                        tnSiteCode: JSON.stringify(itm)
                    }));
                    setLockSite(true);
                    getMMToningPresets(itm.mmSiteCode).then(data=>{
                        setToningPresetList(data);
                    })
                }
            })
        }
    }

    const setRequestSite=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnSiteCode: JSON.stringify(el.value)
        }));
        getMMToningPresets(el.value.mmSiteCode).then(data=>{
            setToningPresetList(data);
        })
    }

    const setRequestPreset=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnPreset: JSON.stringify(el.value)
        }));
    }

    const setRequestDue=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnDueWithin: JSON.stringify(el.value)
        }));
    }

    const setRequestJobType=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnJobType: JSON.stringify(el.value)
        }));
    }

     const setRequestColorOption=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnColor: JSON.stringify(el.value)
        }));
    }

    const setRequestCropping=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnCropping: el.value
        }));
    }
    const setRequestCroppingX=(el:InputChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnCroppingX: el.value
        }));
    }

    const setRequestCroppingY=(el:InputChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnCroppingY: el.value
        }));
    }

    const setRequestCOBType=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnCOBType: JSON.stringify(el.value)
        }));
    }
    const setRequestRetFormat=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnReturnFormat: JSON.stringify(el.value)
        }));
    }

    const setRequestRetRes=(el:DropDownListChangeEvent)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnReturnRes:(el.value)
        }));
    }

    const setRequestInstructions = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNewRequest(prevObject => ({
            ...prevObject,
            tnInstructions: event.target.value
        }));
    }

    const setRequestDescription=(el:React.ChangeEvent<HTMLTextAreaElement>)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnJobDescription: el.target.value
        }));
    }



    const uploadRef = useRef<Upload>(null);
    const saveFileState=(files:Array<UploadFileInfo>)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            tnFileList: files
        }));
    }
    function removeFile(event:UploadOnRemoveEvent){
        saveFileState(event.newState);
    }
    function addFile(event:UploadOnAddEvent){
        saveFileState(event.newState);
        event.affectedFiles.forEach(file=>{
            console.log(event);
        })
    }

    const BuildForm=(props:FormRenderProps)=>{
        return(
            <FormElement>
                <fieldset>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                               <Label editorId="mmSiteList" >Site Code:</Label>                    
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmSiteList"
                                    data={siteList}
                                    dataItemKey="mmSiteCode"
                                    textField="mmNewspaper"
                                    onChange={setRequestSite}
                                    value={newRequest && newRequest.tnSiteCode!=""?JSON.parse(newRequest.tnSiteCode):""}
                                    disabled={lockSite}         
                                />
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmTonigPreset" >Toning Preset:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmToningPreset"
                                    data={toningPresetList}
                                    dataItemKey="mmToningPresetId"
                                    textField="mmToningPresetName"
                                    onChange={setRequestPreset}
                                    value={newRequest && newRequest.tnPreset!==""?JSON.parse(newRequest.tnPreset):""}   
                                />
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmTunaroundTime" >Due Within:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmTurnAroundTime"
                                    data={turnaroundList}
                                    dataItemKey="mmMins"
                                    textField="mmName"
                                    onChange={setRequestDue}
                                    value={newRequest? newRequest.tnDueWithin!==""?JSON.parse(newRequest.tnDueWithin):"":""}
                                    disabled={lockDueWithin}         
                                />
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmJobType" >Job Type:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmJobType"
                                    data={jobTypeList}
                                    dataItemKey="mmJobType"
                                    textField="mmJobType"
                                    onChange={setRequestJobType}
                                    value={newRequest? newRequest.tnJobType!==""?JSON.parse(newRequest.tnJobType):"":""}
                                    disabled={lockJobType}         
                                />
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmColorOption" >Color Option:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmColorOption"
                                    data={colorOptionList}
                                    dataItemKey="mmColorValue"
                                    textField="mmColorOption"
                                    onChange={setRequestColorOption}
                                    value={newRequest && newRequest.tnColor!=""?JSON.parse(newRequest.tnColor):""}
                                    disabled={lockColor}         
                                />
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmCropping" >Needs Cropping:</Label>
                            </Col>
                            <Col xs="2">
                                <DropDownList
                                    id="mmCropping"
                                    data={["No","Yes"]}
                                    onChange={setRequestCropping}
                                    value={newRequest?newRequest.tnCropping:""}
                                    disabled={lockCropping}         
                                />
                            </Col>
                            <Col xs="3">
                                <Input onChange={setRequestCroppingX}></Input>
                            </Col>
                            <Col xs="1" style={{textAlign:"center"}}>X</Col>
                            <Col xs="3">
                                <Input onChange={setRequestCroppingY}></Input>
                            </Col>
                        </Row>
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmCOBType" >COB Type:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmCOBType"
                                    data={cobTypeList}
                                    dataItemKey="mmCOBType"
                                    textField="mmCOBType"
                                    onChange={setRequestCOBType}
                                    value={newRequest && newRequest.tnCOBType!==""?JSON.parse(newRequest.tnCOBType):""}
                                    disabled={lockCOBType}         
                                />
                            </Col>
                        </Row>                    
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmReturnFormat" >Return Format:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmReturnFormat"
                                    data={retFormatList}
                                    dataItemKey="mmReturnFormat"
                                    textField="mmReturnFormat"
                                    onChange={setRequestRetFormat}
                                    value={newRequest && newRequest.tnReturnFormat!==""?JSON.parse(newRequest.tnReturnFormat):""}
                                    required={true}
                                    disabled={lockRetFormat}        
                                />
                            </Col>
                        </Row>                                 
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmReturnRes" >Return Resolution:</Label>
                            </Col>
                            <Col xs="9">
                                <DropDownList
                                    id="mmReturnRes"
                                    data= {["72", "200", "300"]}
                                    onChange={setRequestRetRes}
                                    value={newRequest?newRequest.tnReturnRes.toString():""}
                                    disabled={lockRes}         
                                />
                            </Col>
                        </Row>                                      
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmInstructions" >Special Instructions:</Label>
                            </Col>                        
                            <Col xs="9">
                                <textarea id="mmInstructions" data-role="editor" data-maxtextlength="3000" data-maxtextlength-msg="Text must be shorter than 256 chars" style={{width:"100%"}} onChange={setRequestInstructions}></textarea>   
                            </Col>
                        </Row>                                      
                    </FieldWrapper>
                    <FieldWrapper>
                        <Row>
                            <Col xs="3">
                                <Label editorId="mmDescription" >Job Description:</Label>
                            </Col>
                            <Col xs="9">
                                <textarea id="mmDescription" data-role="editor" data-maxtextlength="3000" data-maxtextlength-msg="Text must be shorter than 256 chars" style={{width:"100%"}} onChange={setRequestDescription}></textarea>   
                            </Col>
                        </Row>                                            
                    </FieldWrapper>
                    <Upload
                        ref={uploadRef}
                        files={newRequest.tnFileList}
                        autoUpload={false}
                        onAdd={addFile}
                        onRemove={removeFile}
                        withCredentials={false}
                        saveUrl={"/api/TestUpload"}
                        restrictions={{allowedExtensions: typeLimit, maxFileSize:parseInt(pageContext?.glSettings.MaxUploadsize ?? '100000')}}
                    />
                </fieldset>
            </FormElement>
        )
    }
    interface toningPreset{
            mmDisplayOrder:number 
            mmToningPresetAvailable:number 
            mmToningPresetCOPOptionId:string 
            mmToningPresetColorOptionId:string 
            mmToningPresetCreatedAt:string 
            mmToningPresetCreatedById:string 
            mmToningPresetFileFormatId:string 
            mmToningPresetId:string 
            mmToningPresetJobTypeId:string 
            mmToningPresetName:string 
            mmToningPresetNeedsCropping:number 
            mmToningPresetPPIResolution:string 
            mmToningPresetRoutingCodeId:string 
            mmToningPresetSiteId:string 
            mmToningPresetSpecialInstructions:string 
            mmToningPresetUpdatedAt:string
        } 

    const setFormValue = (field:string, value:string)=>{
        setNewRequest(prevObject => ({
            ...prevObject,
            [field]: value
        }));
    }    

    const setPresets=()=>{
        let simpleMode:boolean=false
        if (pageContext?.glSettings.MMSimpleMode.toString().toLowerCase()==="true"){
            simpleMode=true
        }
        console.log("Simple Mode: " + simpleMode);
        if(newRequest.tnPreset!=""){
            const tnPreset:toningPreset= JSON.parse(newRequest.tnPreset);
            console.log(tnPreset);
            if (tnPreset.mmToningPresetJobTypeId!=""){
                //set job type
                jobTypeList.forEach(type=>{
                    if (type["mmJobType"]==tnPreset.mmToningPresetJobTypeId){
                        setFormValue("tnJobType",JSON.stringify(type));
                        setLockJobType(true);
                    }
                })
            }
            if (tnPreset.mmToningPresetColorOptionId!=""){
                //set color
                console.log(colorOptionList);
                colorOptionList.forEach(color=>{
                    if (color["mmColorValue"]==tnPreset.mmToningPresetColorOptionId){
                        setFormValue("tnColor",JSON.stringify(color));
                        setLockColor(true);
                    }
                })
            }
            if (tnPreset.mmToningPresetCOPOptionId!=""){
                console.log(cobTypeList)
            }
        }else{
            setLockRes(false);
            setLockCropping(false);
            setLockJobType(false);
            setLockColor(false);
        }
        if (simpleMode===true){
            if (colorOptionList.length>0){
                setFormValue("tnColor", JSON.stringify(colorOptionList[0]));
                setLockColor(true);
            }
            if (turnaroundList.length>0){
                setFormValue("tnDueWithin", JSON.stringify(turnaroundList[1]));
                setLockDueWithin(true);
            }
            if (jobTypeList.length>0){
                setFormValue("tnJobType", JSON.stringify(jobTypeList[0]));
                setLockJobType(true);
            }
            if (retFormatList.length>0){
                setFormValue("tnReturnFormat", JSON.stringify(retFormatList[0]));
                setLockRetFormat(true);
            }
            setFormValue("tnCropping", "NO");
            setLockCropping(true);
            if (cobTypeList.length>0){
                setFormValue("tnCOBType",JSON.stringify(cobTypeList[1]));
                setLockCOBType(true);
            }
            setFormValue("tnReturnRes","200");
            setLockRes(true);
        }else{

        }
    }

    const submitRequest=()=>{
        if (newRequest.tnFileList.length>0){
            if (newRequest.tnReturnFormat!=""){
                submitToningRequest(newRequest).then(()=>{
                    props.onClose();
                }
                );
            }
        }else{
            setNoFiles(true);
        }
    }

    useEffect(()=>{
        setPresets();
        console.log(newRequest.tnPreset);
    },[newRequest.tnPreset])

    useEffect(()=>{
        console.log(newRequest);
    },[newRequest])

    useEffect(()=>{
        setUserSite();
    },[siteList])


    useEffect(()=>{
        setPresets();
        console.log(newRequest.tnPreset);
    },[newRequest.tnSiteCode])
    useEffect(() => {
        const limitTypes:string[] = []; 
        types.forEach(type=>{
            limitTypes.push(type.extension);
        })
        setTypeLimit(limitTypes);
        onLoad();
    }, []);



    return(
        <Window 
            id="submitWindow" 
            title={props.title} 
            onClose={confirmClose} 
            initialHeight={height} 
            width={width} 
            minimizeButton={()=> null}
            maximizeButton={()=> null}
            restoreButton={()=> null}
        >
            {noFiles?<AlertDialog type="WARN" title="No Files Selected" message="You must select one or more files to upload" confirmButtonText="Ok" onClose={hideFileWarning}></AlertDialog>:null}
            {showCloseConfirm?<ConfirmDialog type="WARN" title='WARNING' message='Your submission is incomplete and will not be processed. Are you sure you want to close this window?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={confirmCloseWindow} onClose={closeConfirmWindow}   ></ConfirmDialog>:null}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Form
                render={BuildForm}
                onSubmit={submitRequest}
            />
            </div>
            <WindowActionsBar>
            <Button type="submit" className="primary" onClick={submitRequest}>Submit</Button>
            <Button type="button" onClick={confirmClose}>Cancel</Button>
          </WindowActionsBar>
        </Window>
    )
}
